import { render, staticRenderFns } from "./PortletCard.vue?vue&type=template&id=21caafa8&scoped=true&"
import script from "./PortletCard.vue?vue&type=script&lang=js&"
export * from "./PortletCard.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PortletCard.vue?vue&type=style&index=0&id=21caafa8&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21caafa8",
  null
  ,true
)

export default component.exports